import {lazy} from 'react';
import {RouteConfig} from '@bobex/react-core/routes/RouteConfig';

export const protectedRoutes: RouteConfig[] = [
  {
    key: 'Dashboard',
    path: 'dashboard',
    component: lazy(() => import('@/pages/Dashboard/Dashboard')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'UserDetails',
    path: 'user/:userId/:tabValue',
    component: lazy(() => import('@/pages/Users/UserDetailsPage')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'GovexProfileDetail',
    path: 'user/:userId/govexprofile/:profileId/:tab?',
    component: lazy(() => import('@/pages/Users/GovexProfile/GovexProfileDetail')),
    authority: ['READ_GOVEXPROFILEMODEL'],
  },
  {
    key: 'GovexProfileEdit',
    path: 'user/:userId/govexprofile/:profileId/edit',
    component: lazy(() => import('@/pages/Users/GovexProfile/GovexProfileEdit')),
    authority: ['UPDATE_GOVEXPROFILEMODEL'],
  },
  {
    key: 'GovexProfileCreate',
    path: 'user/:userId/govexprofile/create',
    component: lazy(() => import('@/pages/Users/GovexProfile/GovexProfileEdit')),
    authority: ['UPDATE_GOVEXPROFILEMODEL'],
  },

  {
    key: 'GovexSubscriptionRenewals',
    path: 'subscription_renewals',
    component: lazy(() => import('@/pages/Subscriptions/GovexSubscriptionRenewalsPage')),
    authority: ['READ_INVOICE'],
  },
  {
    key: 'GovexSubscriptionRenewalsTest',
    path: 'subscription_renewals_test',
    component: lazy(() => import('@/pages/Subscriptions/GovexSubscriptionRenewalsPage')),
    authority: ['READ_INVOICE'],
  },
  {
    key: 'MonthlyTargets',
    path: 'monthly-targets',
    component: lazy(() => import('@/pages/MonthlyTargets/MonthlyTargets')),
    authority: ['READ_INVOICE', 'VIEW_CHARTS'],
  },
  {
    key: 'InvoicesByVendor',
    path: 'invoices-by-vendor',
    component: lazy(() => import('@/pages/InvoicesByVendor/InvoicesByVendorPage')),
    authority: ['READ_INVOICE', 'VIEW_CHARTS'],
  },
  {
    key: 'PartnerRfpGenLeads',
    path: 'partner-rfp-gen-leads',
    component: lazy(() => import('@/pages/PartnerRfpGenLeads/PartnerRfpGenLeadsPage')),
    authority: ['PARTNER_RFP_SEARCH'],
  },
  {
    key: 'TeasingAwaitingTestAbo',
    path: 'teasing-awaiting-test-abo',
    component: lazy(() => import('@/pages/TeasingAwaitingTestAbo/TeasingAwaitingTestAboPage')),
    authority: ['PARTNER_RFP_SEARCH'],
  },
  {
    key: 'GovexAllInvoices',
    path: 'all-invoices',
    component: lazy(() => import('@/pages/GovexAllInvoices/GovexAllInvoicesPage')),
    authority: ['READ_INVOICE'],
  },
  {
    key: 'GovexAllCreditNotes',
    path: 'all-credit-notes',
    component: lazy(() => import('@/pages/GovexAllCreditNotes/GovexAllCreditNotesPage')),
    authority: ['READ_CREDIT_NOTE'],
  },
  {
    key: 'PaymentsDashboard',
    path: 'payments-dashboard',
    component: lazy(() => import('@/pages/PaymentsDashboard/PaymentsDashboard')),
    authority: ['VIEW_CHARTS_ADMIN'],
  },
  {
    key: 'LawyerDashboard',
    path: 'lawyer-dashboard',
    component: lazy(() => import('@/pages/LawyerDashboard/LawyerDashboard')),
    authority: ['READ_LAWYER_DASHBOARD'],
  },
  {
    key: 'InvoiceVsPaid',
    path: 'invoice-vs-paid',
    component: lazy(() => import('@/pages/InvoiceVsPaid/InvoiceVsPaid')),
    authority: ['VIEW_CHARTS_ADMIN'],
  },
  {
    key: 'SearchUser',
    path: 'search-user',
    component: lazy(() => import('@/pages/SearchUser/SearchUser')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'SearchSubscription',
    path: 'search-subscription',
    component: lazy(() => import('@/pages/SearchSubscription/SearchSubscription')),
    authority: ['READ_INVOICE'],
  },
  {
    key: 'Send to Lawyer',
    path: 'send-to-lawyer',
    component: lazy(() => import('@/pages/SendToLawyer/SendToLawyer')),
    authority: ['READ_SEND_TO_LAWYER'],
  },
  {
    key: 'ChartsHome',
    path: 'charts-home',
    component: lazy(() => import('@/pages/ChartsHome/ChartsHome')),
    authority: ['VIEW_CHARTS', 'READ_INVOICE'],
  },
  {
    key: 'Sitemap',
    path: 'sitemap',
    component: lazy(() => import('@/pages/Sitemap/Sitemap')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'User Similarities',
    path: 'user-similarities',
    component: lazy(() => import('@/pages/UserSimilarities/UserSimilarities')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'BdaTools',
    path: 'bda-tools',
    component: lazy(() => import('@/pages/BdaTools/BdaTools')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    key: 'BdaLots',
    path: 'bda-lots',
    component: lazy(() => import('@/pages/BdaLots/BdaLots')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    key: 'BdaDetail',
    path: 'bda/:bdaId/:tab?',
    component: lazy(() => import('@/pages/BdaDetail/BdaDetail')),
    authority: ['READ_BDA'],
  },
  {
    // BOB-216 BDA creation LOCAL (replaces legacy /bo_bda_local_add).
    key: 'BdaCreateLocal',
    path: 'bda-create-local',
    component: lazy(() => import('@/pages/BdaCreate/BdaCreateLocal')),
    authority: ['MANAGE_BDA_DETAIL'],
  },
  {
    // BOB-216 BDA creation PV (replaces legacy /bo_bda_pv_add).
    key: 'BdaCreatePv',
    path: 'bda-create-pv',
    component: lazy(() => import('@/pages/BdaCreate/BdaCreatePv')),
    authority: ['MANAGE_BDA_DETAIL'],
  },
  {
    // REGOBO-37 BDA search (replaces legacy bo_bda_searchform). READ_BDA like the BDA detail.
    key: 'BdaSearch',
    path: 'bda-search',
    component: lazy(() => import('@/pages/BdaSearch/BdaSearch')),
    authority: ['READ_BDA'],
  },
  {
    // REGOBO-39 BDA import errors (replaces legacy bo_bda_errors_search). READ_BDA like the BDA detail.
    key: 'BdaErrorSearch',
    path: 'bda-error-search',
    component: lazy(() => import('@/pages/BdaErrorSearch/BdaErrorSearch')),
    authority: ['READ_BDA'],
  },
  {
    // REGOBO-45 BDA upload (replaces legacy prepare_bda_file / prepare_bda2023_file /
    // prepare_bda2023_or_file). MANAGE_BDA_JOUE like the BDA tools / BDA lots / BDA backfill pages.
    key: 'BdaUpload',
    path: 'bda-upload',
    component: lazy(() => import('@/pages/BdaUpload/BdaUpload')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    // REGOBO-45 §1/§5 / REGOBO-45 BDA mail init (read-only: last-sent + detail). Replaces the
    // read-only slice of legacy init_bdamail / view_bdamail (sending / simulation stay on legacy).
    // MANAGE_BDA_JOUE like the other BDA management pages.
    key: 'BdaMailInit',
    path: 'bda-mail-init',
    component: lazy(() => import('@/pages/BdaMailInit/BdaMailInit')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    // BOB-245 JOUE/TNL upload (replaces legacy prepare_joue_file + prepare_tnl_file).
    // MANAGE_BDA_JOUE like the BDA upload / BDA mail init pages.
    key: 'JoueUpload',
    path: 'joue-upload',
    component: lazy(() => import('@/pages/JoueUpload/JoueUpload')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    // BOB-245 JOUE mail init (read-only: last-sent + detail). Replaces the read-only slice of
    // legacy init_jouemail / view_jouemail (sending / simulation stay on the profile page).
    // MANAGE_BDA_JOUE like the other JOUE management pages.
    key: 'JoueMailInit',
    path: 'joue-mail-init',
    component: lazy(() => import('@/pages/JoueMailInit/JoueMailInit')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    // REGOBO-40 Govex reminders list (replaces legacy list_reminder.jsp + govex_rappels_quicklink.jsp).
    // READ_RAPPEL, same authority as the per-subscription rappel endpoints. Both Sitemap links land here.
    key: 'GovexRappelList',
    path: 'govex-rappel-list',
    component: lazy(() => import('@/pages/GovexRappelList/GovexRappelList')),
    authority: ['READ_RAPPEL'],
  },
  {
    key: 'JoueLots',
    path: 'joue-lots',
    component: lazy(() => import('@/pages/JoueLots/JoueLots')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    key: 'JoueTools',
    path: 'joue-tools',
    component: lazy(() => import('@/pages/JoueTools/JoueTools')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    key: 'JoueDetail',
    path: 'joue/:joueId/:tab?',
    component: lazy(() => import('@/pages/JoueDetail/JoueDetailHost')),
    authority: ['READ_JOUE'],
  },
  {
    // REGOBO-38 JOUE search (replaces legacy bo_joue_searchform). READ_JOUE like the JOUE detail.
    key: 'JoueSearch',
    path: 'joue-search',
    component: lazy(() => import('@/pages/JoueSearch/JoueSearch')),
    authority: ['READ_JOUE'],
  },
  {
    // REGOBO-39 JOUE import errors (replaces legacy bo_joue_errors_search). READ_JOUE like the JOUE detail.
    key: 'JoueErrorSearch',
    path: 'joue-error-search',
    component: lazy(() => import('@/pages/JoueErrorSearch/JoueErrorSearch')),
    authority: ['READ_JOUE'],
  },
  {
    // REGOBO-42 recent mail errors (replaces legacy recent_mail_errors.jsp). One container page
    // renders both the BDA and JOUE send-failure tables. AuthorityGuard/hasAuthority treats
    // multiple entries as OR, so either authority alone is enough to reach the page.
    key: 'RecentMailErrors',
    path: 'mail-errors',
    component: lazy(() => import('@/pages/RecentMailErrors/RecentMailErrors')),
    authority: ['READ_BDA', 'READ_JOUE'],
  },
  {
    key: 'AdminList',
    path: 'administrator',
    component: lazy(() => import('@/pages/AdminList/AdminList')),
    authority: ['READ_ADMINISTRATOR'],
  },
  {
    key: 'Token Manager',
    path: 'token-manager',
    component: lazy(() => import('@/pages/TokenManagerPage/TokenManagerPage')),
    authority: ['MANAGE_TOKENS'],
  },
];
